module.exports = __webpack_public_path__ + "img/vertical_3_3_3016.8a5a2323.png";